import { observable, computed, makeAutoObservable } from 'mobx';
import { SdkStaff, StaffSrgUserAnswerType } from 'src/AppState/sdk/staff';
import { Resource } from 'src_common/common/mobx-utils/Resource';

interface UserAnswersReady {
    answer: string | undefined;
    question: string;
    passed: boolean;
}

export class SrgQuestionnaireState {
    @observable public resultArray: boolean = false;

    private readonly srgFormCustomerResponse: Resource<StaffSrgUserAnswerType>;

    public constructor(
        private readonly sdkStaff: SdkStaff,
        private readonly customerId: number
    ) {
        this.srgFormCustomerResponse = new Resource(async (): Promise<StaffSrgUserAnswerType> => {
            return this.sdkStaff.getSrgUserAnswer({ user_id: this.customerId.toString() });
        });
        makeAutoObservable(this);
    }

    @computed public get srgFormResponse(): StaffSrgUserAnswerType | null {
        const result = this.srgFormCustomerResponse.get();

        if (result.type === 'ready') {
            return result.value;
        }

        return null;
    }

    @computed public get isSrgPassed(): boolean {
        return this.srgFormResponse?.answerAudit?.srgPassed ?? false;
    }
    @computed public get userAnswersReady(): UserAnswersReady[] {
        const solution = [];

        if (
            this.srgFormResponse === null ||
            this.srgFormResponse.questionSet === null ||
            this.srgFormResponse.questionSet === undefined ||
            this.srgFormResponse.answerAudit === null ||
            this.srgFormResponse.answerAudit === undefined
        ) {
            return [];
        }

        for (const questionId in this.srgFormResponse.questionSet.questions) {
            const question = this.srgFormResponse.questionSet.questions[questionId];
            const userAnswerValue = this.srgFormResponse.answerAudit.answers[questionId];

            if (question === undefined) {
                break;
            }

            const passed = userAnswerValue === question.answer;

            solution.push({
                answer: userAnswerValue,
                question: question.question,
                passed: passed,
            });
        }

        return solution;
    }
}
